package br.com.htms.inspeccaocampo.data

object TreinamentoDados {
    fun formularioExemplo(): FormInspecao = FormInspecao(
        tstResponsavel = "TST Treinamento",
        obra = "MATRIZ ADM-ENERGIA",
        responsavelFrente = "Responsável Exemplo",
        descricaoAtividade = "Manutenção preventiva em linha de transmissão 500 kV.",
        efetivo = "6",
        localTexto = "-22.123456S, -47.654321W\nCampinas SP BR",
        latitude = -22.123456,
        longitude = -47.654321,
        itens = InspecaoCatalog.itensPadrao().mapIndexed { index, item ->
            when (index) {
                0, 2, 3, 4, 5, 6, 7 -> item.copy(resposta = RespostaTernaria.SIM)
                1 -> item.copy(resposta = RespostaTernaria.NA, justificativa = "Atividade sem PT neste dia.")
                else -> item.copy(
                    resposta = RespostaTernaria.NAO,
                    justificativa = "Exemplo de não conformidade."
                )
            }
        },
        desviosEncontrados = SecaoSimNao(RespostaSimNao.NAO),
        acoesCorretivas = SecaoSimNao(RespostaSimNao.NAO),
        conclusao = "Inspeção de exemplo para treinamento. Não será salva no histórico real."
    )
}
